import React from 'react';
import { ButtonLink } from '../common';
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';
import { getBuyflowLink } from '../../utils/helpers';

import './FooterSectionCTA.scss';

export interface IFooterSectionCTAProps {
  shopLink?: string;
  signInLink?: string;
  isRental?: boolean;
  isEvent?: boolean;
  isStrapiTitle?: boolean;
  analytics: any;
}

const FooterSectionCTA = ({
  shopLink = '',
  signInLink = '',
  isRental = false,
  isEvent = false,
  isStrapiTitle = false,
  analytics,
}: IFooterSectionCTAProps) => {
  const headerText = isEvent
    ? 'Pay-Per-View Events'
    : isRental
    ? 'the Latest Releases'
    : '';

  const visitId = useVisitId();
  const { contextToken } = useContextToken();
  const buyflowLinkHowToRent = getBuyflowLink(
    'https://www.spectrum.net/support/tv/tvod-purchase-and-rental-faq?cid=sspp_sod_gm_tmp_howtorent_unauth_050523',
    'https://www.spectrum.net/support/tv/tvod-purchase-and-rental-faq?cid=sspp_sod_gm_tmp_howtorent_auth_050523'
  );

  return (
    <section className="footer-section-cta">
      <div className="footer-section-cta__inner">
        {!isRental && !isStrapiTitle && (
          <h2 className="footer-section-cta__title">
            Watch Anytime on Spectrum TV
          </h2>
        )}

        <div className="footer-section-cta__articles">
          {isRental ? (
            <article className="article">
              <h3 className="article__title">Rent {headerText} </h3>

              <p className="article__description">
                Visit the Video Store from the main menu to rent
                Hollywood&apos;s latest releases. After you rent a title, it’s
                available to watch on your favorite devices for 48 hours.
              </p>
              <div className="article__buttons">
                {/* Shop */}
                <ButtonLink
                  type="primary"
                  path={shopLink}
                  onClick={() =>
                    analytics.track('SpectrumOnDemand_selectAction_signIn')
                  }
                  tealiumConfig={{
                    dataLinkType: 'footer-section-cta__primary-button',
                    dataLinkName: 'Shop',
                  }}
                >
                  Shop
                </ButtonLink>

                {/* Watch */}
                <ButtonLink
                  type="transparent"
                  path={
                    isEvent
                      ? `https://www.spectrum.net/support/tv/spectrum-pay-view-events?cmp=sod_ppv_event&visitId=${visitId}${contextToken}`
                      : `${buyflowLinkHowToRent}&visitId=${visitId}${contextToken}`
                  }
                  onClick={() => {
                    analytics.track('selectAction', {
                      currPageElemStdName: `FooterSectionCTA__how-to-rent`,
                      msgCategory: 'navigation',
                      msgTriggeredBy: 'user',
                      opType: 'navigationClick',
                    });
                  }}
                  tealiumConfig={{
                    dataLinkType: 'footer-section-cta__transparent-button',
                    dataLinkName: 'How to Rent',
                  }}
                >
                  How to Rent
                </ButtonLink>
              </div>
            </article>
          ) : isStrapiTitle ? (
            <article className="article">
              <h3 className="article__title">
                Explore What Spectrum TV Has to Offer
              </h3>

              <p className="article__description">
                Thousands of On Demand titles available anytime
              </p>

              <div className="article__buttons">
                {/* Explore Movies */}
                <ButtonLink
                  type="secondary"
                  path="/movies/"
                  onClick={() => () =>
                    analytics.track('selectAction', {
                      currPageElemStdName: 'FooterSectionCTA__explore-movies',
                      msgCategory: 'navigation',
                      msgTriggeredBy: 'user',
                      opType: 'buttonClick',
                    })
                  }
                  tealiumConfig={{
                    dataLinkType: 'footer-section-cta__secondary-button',
                    dataLinkName: 'Explore Movies',
                  }}
                >
                  Explore Movies
                </ButtonLink>

                {/* Explore TV Shows */}
                <ButtonLink
                  type="secondary"
                  path="/tv/"
                  onClick={() =>
                    analytics.track('selectAction', {
                      currPageElemStdName: 'FooterSectionCTA__explore-tv-shows',
                      msgCategory: 'navigation',
                      msgTriggeredBy: 'user',
                      opType: 'buttonClick',
                    })
                  }
                  tealiumConfig={{
                    dataLinkType: 'footer-section-cta__secondary-button',
                    dataLinkName: 'Explore TV Shows',
                  }}
                >
                  Explore TV Shows
                </ButtonLink>
              </div>
            </article>
          ) : (
            <>
              <article className="article">
                <h3 className="article__title">Get Spectrum TV Today</h3>

                <p className="article__description">
                  Subscribe to Spectrum TV and start watching today.
                </p>

                {/* Shop */}
                <ButtonLink
                  type="primary"
                  path={shopLink}
                  onClick={() =>
                    analytics.track('SpectrumOnDemand_selectAction_shop')
                  }
                  tealiumConfig={{
                    dataLinkType: 'footer-section-cta__primary-button',
                    dataLinkName: 'Shop',
                  }}
                >
                  Shop
                </ButtonLink>
              </article>

              <article className="article">
                <h3 className="article__title">
                  Already a Spectrum TV subscriber?
                </h3>

                <p className="article__description">
                  Watch live TV and thousands of shows and movies available
                  anytime.
                </p>

                {/* Watch */}
                <ButtonLink
                  type="secondary"
                  path={signInLink}
                  onClick={() =>
                    analytics.track('SpectrumOnDemand_selectAction_signIn')
                  }
                  // tealiumConfig={{
                  //   dataLinkType: 'footer-section-cta__outline-button',
                  //   dataLinkName: 'Sign In',
                  // }}
                >
                  Watch
                </ButtonLink>
              </article>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default FooterSectionCTA;
